import React, { useState, useEffect  } from 'react';
import { Bar, Line, Doughnut, Pie, Radar, Scatter, Bubble } from 'react-chartjs-2';
import * as XLSX from 'xlsx';
import axios from 'axios';
import Select from 'react-select';


import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css'; // Import the CSS file

import ReactECharts from 'echarts-for-react';
import { MapContainer, TileLayer, GeoJSON } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

import { Chrono } from 'react-chrono';

import { ReactComponent as RightIcon } from '../icons/home/right.svg';
import { ReactComponent as LeftIcon } from '../icons/home/left.svg';
import { ReactComponent as WidgetsBigIcon } from '../icons/widgetsBig.svg';
import { ReactComponent as DashboardsBigIcon } from '../icons/dashboardBig.svg';
import { ReactComponent as DadosBigIcon } from '../icons/databaseBig.svg';
import { ReactComponent as ProjetosBigIcon } from '../icons/folderBig.svg';
import { ReactComponent as HappyIcon } from '../icons/happy.svg';
import { ReactComponent as SadIcon } from '../icons/sad.svg';
import { ReactComponent as TrashIcon } from '../icons/home/trash.svg';
import { ReactComponent as PenIcon } from '../icons/home/pen.svg';
import { ReactComponent as ExportIcon } from '../icons/home/export.svg';
import { ReactComponent as CopyIcon } from '../icons/home/copy.svg';
import { ReactComponent as EyeIcon } from '../icons/home/eye.svg';
import { ReactComponent as ShareIcon } from '../icons/home/share.svg';
import { ReactComponent as SaveIcon } from '../icons/home/save.svg';
import { ReactComponent as timelineIcon } from '../icons/timeline.svg';
import { ReactComponent as timelineHIcon } from '../icons/timelineHorizontal.svg';
import { ReactComponent as spiderIcon } from '../icons/spider.svg';

import { ReactComponent as Group16 } from '../icons/Group16.svg';
import { ReactComponent as Group17 } from '../icons/Group17.svg';
import { ReactComponent as Group18 } from '../icons/Group18.svg';
import { ReactComponent as Group20 } from '../icons/Group20.svg';
import { ReactComponent as Group21 } from '../icons/Group21.svg';
import { ReactComponent as Group22 } from '../icons/Group22.svg';
import { ReactComponent as Group23 } from '../icons/Group23.svg';
import { ReactComponent as Group26 } from '../icons/Group26.svg';
import { ReactComponent as Group27 } from '../icons/Group27.svg';
import { ReactComponent as Group28 } from '../icons/Group28.svg';
import { ReactComponent as Group32 } from '../icons/Group32.svg';
import { ReactComponent as Group33 } from '../icons/Group33.svg';
import { ReactComponent as Group40 } from '../icons/Group40.svg';
import { ReactComponent as Group41 } from '../icons/Group41.svg';
import { ReactComponent as Group43 } from '../icons/Group43.svg';
import { ReactComponent as Group44 } from '../icons/Group44.svg';
import { ReactComponent as Group56 } from '../icons/Group56.svg';

//export const API_BASE_URL = 'http://localhost:3046';
export const API_BASE_URL = 'https://api.dashboards.prochildcolab.pt';

const TableComponent = ({ data }) => {
  // Inline styles for the table and its elements
  const styles = {
    container: {
      overflowX: 'auto',
      maxHeight: 'calc(100% - 70px)', // Set a maximum height
      margin: '20px 0',
    },
    table: {
      width: '100%',
      borderCollapse: 'separate',
      borderSpacing: '0',
      fontFamily: 'Arial, sans-serif',
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    },
    th: {
      padding: '14px 16px',
      textAlign: 'center',
      backgroundColor: '#4e73df', // Dark blue header for contrast
      color: '#ffffff',
      textTransform: 'uppercase',
      fontSize: '14px',
      fontWeight: 'bold',
      position: 'sticky',
      top: 0,
      zIndex: 1,
    },
    td: {
      padding: '12px 16px',
      textAlign: 'center',
      borderBottom: '1px solid #e0e0e0',
    },
    trOdd: {
      backgroundColor: '#f7f9fc', // Light gray for even rows
    },
    trEven: {
      backgroundColor: '#ffffff', // White for odd rows
    },
    labelCell: {
      textAlign: 'left',
      fontWeight: 'bold',
      padding: '12px 16px',
      color: '#4a4a4a',
      backgroundColor: '#f1f5f9',
      borderRight: '1px solid #e0e0e0',
    },
  };

  return (
    <div style={styles.container}>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Label</th>
            {data.labels.map((label, index) => (
              <th key={index} style={styles.th}>
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.datasets.map((dataset, index) => (
            <tr
              key={index}
              style={index % 2 === 0 ? styles.trEven : styles.trOdd}
            >
              <td style={styles.labelCell}>{dataset.label}</td>
              {dataset.data.map((value, valueIndex) => (
                <td key={valueIndex} style={styles.td}>
                  {parseFloat(value).toFixed(2)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const TreemapComponent = ({ data }) => {
  // Transform data into the format required by ECharts
  const transformedData = data.datasets.map((dataset, datasetIndex) => {
    return {
      name: dataset.label,
      children: data.labels.map((label, labelIndex) => {
        return {
          name: label || `No Label ${labelIndex}`,
          value: parseFloat(dataset.data[labelIndex]) || 0,
          itemStyle: {
            color: dataset.backgroundColor,
            borderColor: dataset.borderColor,
            borderWidth: dataset.borderWidth
          }
        };
      }).filter(item => item.value > 0) // Filter out zero values for better visualization
    };
  });

  const option = {
    tooltip: {
      trigger: 'item',
      formatter: (params) => {
        return `${params.name}<br/>Valor: ${params.value}`;
      }
    },
    series: [
      {
        type: 'treemap',
        data: transformedData,
        label: {
          show: true,
          formatter: '{b}'
        },
        itemStyle: {
          borderColor: '#fff'
        }
      }
    ]
  };

  return <ReactECharts option={option} style={{ height: 'calc(100% - 30px)', width: '100%' }} />;
};

const GeoMapComponent = ({ data }) => {
  const [geoJsonData, setGeoJsonData] = useState(null);
  const geoDataset = data.datasets[0] || { data: [] }; // Use the first dataset
  const valueDataset = data.datasets[0] || { data: [] };

  const values = valueDataset.data;
  const geo = data.labels;

  // Create a map of region names to values
  const valueMap = geo.reduce((acc, name, index) => {
    acc[name] = values[index] || 0; // Map region name to its corresponding value, defaulting to 0 if no value exists
    return acc;
  }, {});

  const frequencyMap = geo.reduce((acc, name) => {
    acc[name] = (acc[name] || 0) + 1;
    return acc;
  }, {});

  const maxFrequency = Math.max(...Object.values(frequencyMap), 1);

  // Fetch the Portugal NUTS III GeoJSON data
  useEffect(() => {
    fetch('/nutsII_4326.geojson')
      .then(response => response.json())
      .then(data => {
        if (data && data.features && data.features.length > 0) {
        } else {
          console.warn('No valid features found in GeoJSON data.');
        }
        setGeoJsonData(data);
      })
      .catch(error => console.error('Error fetching GeoJSON data:', error));
  }, []);

// Define a mapping of static colors for features
const featureColors = {
  "ALGARVE": "#FF5733", // Example color for FeatureName1
  "NORTE": "#9B59B6", // Example color for FeatureName2
  "ALENTEJO": "#3357FF", // Example color for FeatureName3
  "CENTRO": "#F5A623", // Example color for FeatureName4
  "AREA METROPOLITANA DE LISBOA": "#33FF57"  // Example color for FeatureName5
};

// Define a function to style the regions based on properties
const styleFeature = (feature) => {
  const name = feature.properties.NUTE_NAME; // Get feature name
  const count = frequencyMap[name] || 0; // Lookup frequency

  // Normalize opacity so the most repeated entry has opacity of 1
  const fillOpacity = count > 0 ? 0.3 + (count / maxFrequency) * 0.4 : 0; // Base opacity at 0.3 up to 0.7

  // Assign the static color from the featureColors map
  const fillColor = featureColors[name] || "#CCCCCC"; // Default to grey if no color is found

  return {
    fillColor: fillColor,
    weight: count > 0 ? 2 : 0,
    opacity: count > 0 ? 1 : 0,
    color: count > 0 ? 'white' : 'transparent',
    dashArray: count > 0 ? '3' : '0',
    fillOpacity: fillOpacity,
  };
};


  // Define a function to handle when a region is clicked
  const onEachFeature = (feature, layer) => {
    const name = feature.properties.NUTE_NAME;
    const value = valueMap[name] || 'No data'; // Display "No data" if value is not available

    layer.on('click', () => {
      layer.bindPopup(`
        <strong>${name}</strong><br />
        ${valueDataset.label}: ${value}
      `);
      layer.openPopup();
    });
  };

  return (
    <div style={{ maxHeight: 'calc(100% - 10px)', width: '100%', height: '100%',margin: 'auto' }}>
    <MapContainer
    attributionControl={false} // Disable the default attribution
    center={[39.6, -8.0]}
    zoom={6}
    style={{ height: '100%', width: '100%' }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {geoJsonData && (
        <GeoJSON
          data={geoJsonData}
          style={styleFeature}
          onEachFeature={onEachFeature}
        />
      )}
    </MapContainer>
    </div>
  );
};


const Sumatorio = ({ data }) => {
  const [calcType, setCalcType] = useState('average');

  const calculateSum = () => {
    if (!data || data.length === 0) return 0;
    const values = data.datasets.flatMap((dataset) =>
      dataset.data.map((value) => parseFloat(value) || 0)
    );
    return values.reduce((acc, value) => acc + value, 0).toFixed(2);
  };

  const calculateAverage = () => {
    if (!data || data.length === 0) return 0;
    const values = data.datasets.flatMap((dataset) =>
      dataset.data.map((value) => parseFloat(value) || 0)
    );
    const sum = values.reduce((acc, value) => acc + value, 0);
    return (sum / values.length).toFixed(2);
  };

  const calculateMedian = () => {
    if (!data || data.length === 0) return 0;
    const values = data.datasets
      .flatMap((dataset) => dataset.data.map((value) => parseFloat(value) || 0))
      .sort((a, b) => a - b);
    const len = values.length;
    const middle = Math.floor(len / 2);
    return len % 2 === 0
      ? ((values[middle - 1] + values[middle]) / 2).toFixed(2)
      : values[middle].toFixed(2);
  };

  const getBigNumber = () => {
    switch (calcType) {
      case 'average':
        return calculateAverage();
      case 'median':
        return calculateMedian();
      case 'sum':
      default:
        return calculateSum();
    }
  };

  // Define button styles with responsiveness to the container
  const buttonStyle = (type) => ({
    margin: '0 0.5rem',
    padding: '0.5em 1em',
    border: 'none',
    borderRadius: '0.5rem',
    backgroundColor: calcType === type ? '#4CAF50' : '#e8f5e9',
    color: calcType === type ? '#fff' : '#4CAF50',
    cursor: 'pointer',
    fontSize: '1em', // Scale with parent font size
    transition: 'background-color 0.3s ease, color 0.3s ease',
    flex: '1 1 auto',
  });

  // Main container style
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    overflowX: 'hidden', // Prevent horizontal scrolling
    overflowY: 'auto', // Enable vertical scrolling
    textAlign: 'center',
    boxSizing: 'border-box',
    // Dynamically scale the base font size with parent container size using percentages
    fontSize: 'min(3vw, 3vh, 1rem)', // Adjust this as needed for scaling balance
  };

  // Big number style that scales with the container
  const bigNumberStyle = {
    fontSize: '1.5em', // This scales based on the container's `fontSize`
    fontWeight: 'bold',
    color: '#4CAF50',
    margin: '0',
    padding: '0.5em 1em',
    borderRadius: '0.5rem',
    backgroundColor: '#e8f5e9',
    boxShadow: 'inset 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
  };

  const bigNumber = getBigNumber();

  return (
    <div style={containerStyle}>
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
        <button onClick={() => setCalcType('sum')} style={buttonStyle('sum')}>
          Sumatório
        </button>
        <button onClick={() => setCalcType('average')} style={buttonStyle('average')}>
          Média
        </button>
        <button onClick={() => setCalcType('median')} style={buttonStyle('median')}>
          Mediana
        </button>
      </div>

      <p style={bigNumberStyle}>{bigNumber}</p>
    </div>
  );
};

const UNUSEDV_Timeline = ({ data }) => {
  // Extracting titles, descriptions, and dates from the provided data structure
  const titles = data.labels || [];
  const descriptionDataset = data.datasets[0] || { data: [] }; // Use the first dataset for descriptions
  const dateDataset = data.datasets[1] || { data: [] }; // Use the second dataset for dates

  let descriptions = descriptionDataset.data;
  let dates = dateDataset.data;

  console.log(dateDataset);

  // Function to convert DD/MM/YYYY or ISO 8601 to YYYY-MM-DD for proper sorting
  const parseDate = (dateString) => {
    if (!dateString) return null; // Return null for invalid date strings

    const trimmedDate = dateString.trim(); // Trim extra spaces

    // Check if the date is in ISO 8601 format (YYYY-MM-DD)
    const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (isoDateRegex.test(trimmedDate)) {
      return new Date(trimmedDate); // ISO 8601 is directly parsed
    }

    // If the date is not in ISO 8601 format, assume it is in DD/MM/YYYY format
    const [day, month, year] = trimmedDate.split('/');
    if (day && month && year) {
      const parsedDate = new Date(`${year}-${month}-${day}`);
      // Check if the date is valid (NaN means invalid date)
      if (isNaN(parsedDate)) {
        console.warn(`Invalid date format: ${trimmedDate}`); // Log any invalid dates
        return null;
      }
      return parsedDate;
    }

    // If the date format doesn't match either, return null
    console.warn(`Invalid date format: ${trimmedDate}`);
    return null;
  };

  // Check if the first dataset contains date-like data (if so, swap descriptions and dates)
  const isFirstDatasetDates = descriptions.every((item) => parseDate(item) !== null);
  if (isFirstDatasetDates) {
    // If the first dataset contains valid date strings, treat it as dates and swap datasets
    descriptions = dateDataset.data;
    dates = descriptionDataset.data;
  }

  // Combine the extracted information into events
  const events = titles.map((title, index) => ({
    title,
    description: descriptions[index] || 'Not available',
    date: dates[index] || 'Not available',
  }));

  // Sort events by date
  const sortedEvents = events.sort((a, b) => {
    const dateA = parseDate(a.date);
    const dateB = parseDate(b.date);

    // Return comparison result for sorting
    return dateA - dateB; // Sort in ascending order (oldest to newest)
  });

  const styles = {
    timelineWrapper: {
      position: 'relative',
      width: '100%',
      maxHeight: 'calc(100% - 35px)', // Set a maximum height for the timeline
      overflowY: 'auto', // Enable vertical scrolling
      overflowX: 'hidden', // Prevent horizontal scrolling
      margin: '0 auto',
      boxSizing: 'border-box', // Include padding and border in the element's total width and height
    },
  };

  return (
    <div style={styles.timelineWrapper}>
      <style>
        {`
          .vertical-timeline::before {
            background: white !important; /* Color of the line */
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.3) !important; /* Shadow effect */
          }
        `}
      </style>
      <VerticalTimeline layout="1-column">
        {sortedEvents.map((event, index) => (
          <VerticalTimelineElement
            key={index}
            contentStyle={{
              background: '#fff',
              color: '#333',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            }}
            contentArrowStyle={{ borderRight: '7px solid #4CAF50' }}
            date={event.date}
            iconStyle={{ background: '#4CAF50', color: '#fff' }}
          >
            <h3 className="vertical-timeline-element-title">{event.title}</h3>
            <p>{event.description}</p>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </div>
  );
};

const UNUSED_HTimeline = ({ data }) => {
  const titles = data.labels || [];
  const descriptionDataset = data.datasets[0] || { data: [] };
  const dateDataset = data.datasets[1] || { data: [] };

  let descriptions = descriptionDataset.data;
  let dates = dateDataset.data;

  const parseDate = (dateString) => {
    if (!dateString) return null;
    const trimmedDate = dateString.trim();

    const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (isoDateRegex.test(trimmedDate)) {
      return new Date(trimmedDate);
    }

    const [day, month, year] = trimmedDate.split('/');
    if (day && month && year) {
      const parsedDate = new Date(`${year}-${month}-${day}`);
      if (isNaN(parsedDate)) {
        console.warn(`Invalid date format: ${trimmedDate}`);
        return null;
      }
      return parsedDate;
    }

    console.warn(`Invalid date format: ${trimmedDate}`);
    return null;
  };

  const isFirstDatasetDates = descriptions.every((item) => parseDate(item) !== null);
  if (isFirstDatasetDates) {
    descriptions = dateDataset.data;
    dates = descriptionDataset.data;
  }

  const events = titles.map((title, index) => ({
    title,
    description: descriptions[index] || 'Not available',
    date: dates[index] || 'Not available',
  }));

  const sortedEvents = events.sort((a, b) => {
    const dateA = parseDate(a.date);
    const dateB = parseDate(b.date);
    return dateA - dateB;
  });

  const styles = {
    timelineWrapper: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      overflowX: 'auto',
      padding: '40px 0',
      boxSizing: 'border-box',
      margin: '0 auto',
      minHeight: '120px', // Ensure there's enough height for the line to be visible
    },
    timelineLine: {
      position: 'absolute',
      top: '50%',
      left: '0',
      width: '100%',
      height: '2px',
      backgroundColor: 'red', // Change the line color to red for debugging
      zIndex: -1, // Ensure it stays behind the events
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.3)', // Adding shadow to the line
    },
    event: {
      display: 'inline-block',
      minWidth: '200px',
      margin: '0 30px',
      background: '#fff',
      color: '#333',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      padding: '20px',
      textAlign: 'center',
      position: 'relative',
      zIndex: 1, // Bring events above the line
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    },
    eventCircle: {
      position: 'absolute',
      top: '-15px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '20px',
      height: '20px',
      backgroundColor: '#4CAF50',
      borderRadius: '50%',
      boxShadow: '0 0 6px rgba(0, 0, 0, 0.2)',
      border: '4px solid white',
    },
    eventTitle: {
      fontSize: '16px',
      fontWeight: 'bold',
      marginBottom: '10px',
    },
    eventDescription: {
      fontSize: '14px',
      marginTop: '10px',
    },
    dateStyle: {
      fontSize: '12px',
      color: '#888',
      marginTop: '10px',
    },
    eventHover: {
      transform: 'scale(1.05)',
      boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
    },
  };

  return (
    <div style={styles.timelineWrapper}>
      {/* The line is placed absolutely in the middle of the timeline */}
      <div style={styles.timelineLine}></div>

      {/* Render the events */}
      {sortedEvents.map((event, index) => (
        <div key={index} style={styles.event} className="timeline-event">
          <div style={styles.eventCircle}></div> {/* Circular marker */}
          <div style={styles.eventTitle}>{event.title}</div>
          <div style={styles.eventDescription}>{event.description}</div>
          <div style={styles.dateStyle}>{event.date}</div>
        </div>
      ))}
    </div>
  );
};

const TimelineComponent = ({ data, mode }) => {
  const titles = data.labels || [];
  const descriptionDataset = data.datasets[0] || { data: [] };
  const dateDataset = data.datasets[1] || { data: [] };

  let descriptions = descriptionDataset.data;
  let dates = dateDataset.data;

  const parseDate = (dateString) => {
    if (!dateString) return null;
    const trimmedDate = dateString.trim();

    const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (isoDateRegex.test(trimmedDate)) {
      return new Date(trimmedDate);
    }

    const [day, month, year] = trimmedDate.split('/');
    if (day && month && year) {
      const parsedDate = new Date(`${year}-${month}-${day}`);
      if (isNaN(parsedDate)) {
        console.warn(`Invalid date format: ${trimmedDate}`);
        return null;
      }
      return parsedDate;
    }

    console.warn(`Invalid date format: ${trimmedDate}`);
    return null;
  };

  const isFirstDatasetDates = descriptions.every((item) => parseDate(item) !== null);
  if (isFirstDatasetDates) {
    descriptions = dateDataset.data;
    dates = descriptionDataset.data;
  }

  // Prepare events for the timeline
  const events = titles.map((title, index) => ({
    title,
    description: descriptions[index] || 'Not available',
    date: parseDate(dates[index]) || new Date(),
  }));

   const sortedEvents = events.sort((a, b) => a.date - b.date);

  // Chrono Timeline data structure
  const timelineItems = sortedEvents.map((event) => ({
    title: event.title,
    cardTitle: event.title,
    cardSubtitle: event.date.toLocaleDateString(),
    cardDetailedText: event.description,
    date: event.date,
  }));

  return (
    <div style={{ maxHeight: 'calc(100% - 30px)', width: '100%', height: '100%',margin: 'auto' }}>
      <Chrono
        items={timelineItems}
        mode={mode}
        slideShow={true}
        buttonTexts={{
    first: 'Saltar para o Primeiro',
    last: 'Saltar para o Último',
    next: 'Próximo',
    previous: 'Anterior',
    play: 'Reproduzir Slideshow'
  }}
        theme={{
          primary: '#F7BE04',     //linha
          secondary: '#43BBC9',   //ponto
          titleColor: '#43BBC9',
          titleColorActive: 'white',
          cardBgColor: 'white', //backgroud card
        }}
        enableLayoutSwitch={false}
        enableQuickJump={false}
        disableToolbar={false}
        cardHeight={'100'}
        itemWidth={'150'}
      />
    </div>
  );
};

const Timeline = (props) => <TimelineComponent {...props} mode="VERTICAL" />;
const HTimeline = (props) => <TimelineComponent {...props} mode="HORIZONTAL" />;


const Titulo = ({ data, id }) => {
  const [title, setTitle] = useState(data); // State to manage the title text

  const styles = {
    titleWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%', // Set a fixed height for centering
      //background: '#f8f8f8', // Light background color for contrast
      //border: '1px solid #ddd', // Optional border for better visibility
      //borderRadius: '8px', // Rounded corners
      //boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
      margin: '0px auto', // Center the title on the page
      boxSizing: 'border-box', // Include padding and border in width and height
    },
    titleInput: {
  fontSize: '24px', // Set font size for the title
  color: '#333', // Dark text color
  fontWeight: 'bold', // Make the title bold
  border: 'none', // Remove default input border
  outline: 'none', // Remove outline on focus
  background: 'transparent', // Make background transparent
  width: '100%', // Full width to match wrapper
  textAlign: 'center', // Center the text
  textShadow: '6px 6px 10px rgba(255, 255, 255, 0.7), -6px -6px 10px rgba(255, 255, 255, 0.7)', // Much larger white shadow effect
}

  };

  // Function to handle updating the title in the database
  const updateTitle = async (newTitle) => {
    try {
      // Get the token from localStorage
      const token = localStorage.getItem('token');

      // Make a PUT request to update the 'conteudo' field for this widget
      const response = await axios.put(
        `${API_BASE_URL}/widgets/${id}/conteudo`,
        { conteudo: newTitle },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the Authorization header
          },
        }
      );

      // Handle success (optional, you can provide feedback to the user)
      console.log("Title updated successfully", response.data);
    } catch (error) {
      // Handle error (you can display an error message to the user)
      console.error("Error updating title:", error);
    }
  };

  // Effect to update the title in the database when the title state changes
  useEffect(() => {
    if (title !== data) {
      // Update the database when the title changes
      updateTitle(title);
    }
  }, [title]); // Only re-run this effect when the title changes

  return (
    <div style={styles.titleWrapper}>
      <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)} // Update state on change
        style={styles.titleInput}
      />
    </div>
  );
};

const Paragrafo = ({ data, id }) => {
  const [paragraph, setParagraph] = useState(data); // State to manage the paragraph text

  const styles = {
    paragraphWrapper: {
      display: 'flex',
      justifyContent: 'center', // Center horizontally
      alignItems: 'center',      // Center vertically
      height: '100%',            // Set height to allow vertical centering
      //background: '#f8f8f8',     // Light background color for contrast
      //border: '1px solid #ddd',  // Optional border for better visibility
      //borderRadius: '8px',       // Rounded corners
      //boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
      margin: '0px auto',       // Center the paragraph on the page
      boxSizing: 'border-box',    // Include padding and border in width and height
      padding: '10px',           // Add padding for better spacing
      minHeight: '60px',         // Minimum height to improve centering
    },
    paragraphInput: {
      fontSize: '16px',          // Set font size for the paragraph
      color: '#333',             // Dark text color
      lineHeight: '1.5',         // Increase line height for better readability
      textAlign: 'center',       // Center the text in the input field
      border: 'none',            // Remove default input border
      outline: 'none',           // Remove outline on focus
      background: 'transparent', // Make background transparent
      width: '100%',             // Full width to match wrapper
      padding: '10px',           // Add padding for better spacing
    },
  };

  // Function to handle updating the paragraph in the database
  const updateParagraph = async (newParagraph) => {
    try {
      // Get the token from localStorage
      const token = localStorage.getItem('token');

      // Make a PUT request to update the 'conteudo' field for this widget
      const response = await axios.put(
        `${API_BASE_URL}/widgets/${id}/conteudo`,
        { conteudo: newParagraph },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the Authorization header
          },
        }
      );

      // Handle success (optional, you can provide feedback to the user)
      console.log("Paragraph updated successfully", response.data);
    } catch (error) {
      // Handle error (you can display an error message to the user)
      console.error("Error updating paragraph:", error);
    }
  };

  // Effect to update the paragraph in the database when the paragraph state changes
  useEffect(() => {
    if (paragraph !== data) {
      // Update the database when the paragraph changes
      updateParagraph(paragraph);
    }
  }, [paragraph]); // Only re-run this effect when the paragraph changes

  return (
    <div style={styles.paragraphWrapper}>
      <input
        type="text"
        value={paragraph}
        onChange={(e) => setParagraph(e.target.value)} // Update state on change
        style={styles.paragraphInput}
      />
    </div>
  );
};

const Imagem = ({ data, id }) => {
  const [image, setImage] = useState(data); // State to manage the current image

  const styles = {
    mainWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',  // Ensure mainWrapper takes up full width of the parent
      height: '100%', // Ensure mainWrapper takes up full height of the parent
      maxHeight: '100%', // Maintain height constraint relative to parent
      maxWidth: '100%', // Maintain width constraint relative to parent
      borderRadius: '8px', // Rounded corners for the container
      //background: 'red', // Background color for contrast
      boxSizing: 'border-box', // Ensure padding and border are considered in width/height
    },
    imageWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      overflow: 'hidden', // Ensure the image does not overflow the wrapper
      boxSizing: 'border-box', // Include padding and border in dimensions
      cursor: 'pointer', // Cursor indicates it's clickable
    },
    image: {
      background: '#f8f8f8',     // Light background color for contrast
      border: '1px solid #ddd',  // Optional border for better visibility
      borderRadius: '8px',       // Rounded corners
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
      maxWidth: '100%', // Ensure the image fits within the wrapper
      maxHeight: '100%', // Ensure the image doesn't exceed the wrapper's height
    },
    hiddenFileInput: {
      display: 'none', // Hide the file input
    },
  };

  // Function to handle image change (file selected)
  const handleFileChange = async (e) => {
    const file = e.target.files[0]; // Get the first file

    if (file) {
      await uploadImage(file);
    }
  };

  // Function to upload the image to the server
  const uploadImage = async (file) => {
    try {
      // Get the token from localStorage
      const token = localStorage.getItem('token');

      // Create a FormData object to hold the file data
      const formData = new FormData();
      formData.append('image', file); // Append the selected file

      // Make a POST request to upload the image
      const response = await axios.post(
        `${API_BASE_URL}/widgets/${id}/upload-image`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`, // Include the Authorization header
          },
        }
      );

      // Update the image state with the new image path after a successful upload
      setImage(response.data.imagePath); // Assuming the API returns the new image path
      alert("Imagem atualizada!");
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("Erro ao atualizar a imagem.");
    }
  };

  // Function to trigger the hidden file input when the image is clicked
  const handleImageClick = () => {
    document.getElementById(`fileInput-${id}`).click(); // Trigger the hidden file input
  };

  return (
    <div style={styles.mainWrapper}>
      {/* Image display area */}
      <div style={styles.imageWrapper} onClick={handleImageClick}>
        <img src={`${API_BASE_URL}/${image}`} alt="" style={styles.image} />
      </div>

      {/* Hidden file input */}
      <input
        type="file"
        id={`fileInput-${id}`} // Unique id based on the widget Id
        style={styles.hiddenFileInput}
        accept="image/*"
        onChange={handleFileChange} // Trigger image upload when a file is selected
      />
    </div>
  );
};


export const chartComponents1 = {
  25: { component: Sumatorio, label: "BigNumber", icon: Group17 }, //sumatório
};

export const chartComponents2 = {
  12: { component: Bar, label: "VerticalStacked", icon: Group20,
  options:{
  maintainAspectRatio: false,
  layout: {
    padding: {
      bottom: 20,
    },
  },
  indexAxis: 'x',
  scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true
      }
    }
}  },
  13: { component: Bar, label: "HorizontalStaked", icon: Group21,
  options:{
  maintainAspectRatio: false,
  layout: {
    padding: {
      right: 17,
      bottom: 25,
    },
  },
  indexAxis: 'y',
  scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true
      }
    }
}  },
  14: { component: Bar, label: "Bar", icon: Group22,
  options:{
  maintainAspectRatio: false,
  layout: {
    padding: {
      bottom: 20,
    },
  },
  indexAxis: 'x',
  scales: {
      x: {
        stacked: false,
      },
      y: {
        stacked: false
      }
    }
}  },
  15: { component: Bar, label: "HorizontalBar", icon: Group23,
  options:{
  maintainAspectRatio: false,
  layout: {
    padding: {
      right: 17,
      bottom: 25,
    },
  },
  indexAxis: 'y',
  scales: {
      x: {
        stacked: false,
      },
      y: {
        stacked: false
      }
    }
}  },
  19: { component: Radar, label: "Radar", icon: spiderIcon,
  options:{
  maintainAspectRatio: false,
  layout: {
    padding: {
      bottom: 20,
    },
  },
} },
  /*16: { component: Pie, label: "Pie", icon: Group24  },*/
};

export const chartComponents3 = {
  3: { component: Pie, label: "Pie", icon: Group26,
  options:{
  maintainAspectRatio: false,
  layout: {
    padding: {
      bottom: 30,
    },
  },
} },
  4: { component: Doughnut, label: "Doughnut", icon: Group27,
  options:{
  maintainAspectRatio: false,
  layout: {
    padding: {
      bottom: 30,
    },
  },
} },
  5: {
  component: TreemapComponent,
  label: "TreemapChart",
  icon: Group28,
  options: {
    // Additional settings specific to Treemap to adjust spacing between nodes
    spacing: 20,  // Adjust node spacing as needed
  },
},

};

export const chartComponents4 = {
  1: { component: Line, label: "Line", icon: Group32,
  options:{
  maintainAspectRatio: false,
  layout: {
    padding: {
      right: 23,
      bottom: 25,
    },
  },
} },
  2: { component: Line, label: "Area", icon: Group33,
    options: {
    maintainAspectRatio: false,
    layout: {
      padding: {
      right: 23,
      bottom: 25,
    },
    },
    scales: {
      x: {
        stacked: false,
        beginAtZero: true, // Optional: adjust based on your needs
      },
      y: {
        stacked: true,
        beginAtZero: true, // Optional: adjust based on your needs
      },
    },
    elements: {
      line: {
        tension: 0.4, // Adjusts the curvature of the line, set to 0 for straight lines
        borderWidth: 2,
        fill: true, // This property is crucial to create the area effect
      },
    },
    plugins: {
      legend: {
        display: true, // Show or hide the legend
        position: 'top', // Position of the legend
      },
      tooltip: {
        enabled: true, // Enables the tooltip on hover
      },
    },
  },
},
  6: { component: Bar, label: "Bar", icon: Group18,
  options:{
  maintainAspectRatio: false,
  layout: {
    padding: {
      bottom: 20,
    },
  },
  indexAxis: 'x',
  scales: {
      x: {
        stacked: false,
      },
      y: {
        stacked: false
      }
    }
}  },
  7: { component: Bar, label: "Horizontal", icon: Group16,
  options:{
  maintainAspectRatio: false,
  layout: {
    padding: {
      bottom: 20,
    },
  },
  indexAxis: 'y',
  scales: {
      x: {
        stacked: false,
      },
      y: {
        stacked: false
      }
    }
}  },
};

const commonOptions = {
  maintainAspectRatio: false,
  scales: {
    x: {
      type: 'category', // Use category type for x-axis
    },
    y: {
      beginAtZero: true, // Ensure y-axis starts at zero
    },
  },
  layout: {
    padding: {
      bottom: 30,
    },
  },
};

export const chartComponents5 = {
  17: {
    component: Scatter,
    label: "Scatter",
    icon: Group41,
    options: commonOptions, // Reuse common options
  },
  18: {
    component: Bubble,
    label: "Bubble",
    icon: Group40,
    options: commonOptions, // Reuse common options
  },
};


export const chartComponents6 = {
  20: { component: GeoMapComponent, label: "Radar", icon: Group44 },
};

export const chartComponents7 = {
  21: { component: TableComponent, label: "TableComponent", icon: Group43 },
  26: { component: Timeline, label: "BigNumber", icon: timelineIcon },
  103: { component: HTimeline, label: "BigNumber", icon: timelineHIcon },
};

export const chartComponents8 = {
  22: { component: Radar, label: "New Dashboard", icon: Group56 },
};

export const chartComponents9 = {
  100: { component: Titulo, label: "TitleDisplay"},
  101: { component: Paragrafo, label: "Paragrafo"},
  102: { component: Imagem, label: "Imagem"},
};

const chartComponentsMap = {
  1: chartComponents1,
  2: chartComponents2,
  3: chartComponents3,
  4: chartComponents4,
  5: chartComponents5,
  6: chartComponents6,
  7: chartComponents7,
  8: chartComponents8,
  9: chartComponents9,
};

export const chartComponents = {
  ...chartComponents1,
  ...chartComponents2,
  ...chartComponents3,
  ...chartComponents4,
  ...chartComponents5,
  ...chartComponents6,
  ...chartComponents7,
  ...chartComponents8,
  ...chartComponents9,
};

const processJsonData = (jsonData, allSheetData) => {
    for (const key in jsonData) {
        if (jsonData.hasOwnProperty(key)) {
            const item = jsonData[key];
            const sheetName = item.IndicadorDsg || 'tabela'; // Use 'table' if IndicadorDsg doesn't exist

            if (!allSheetData[sheetName]) {
                allSheetData[sheetName] = [];
            }

            // Find the correct data property automatically
            const dataProperty = Object.keys(item).find(prop =>
                item[prop] && typeof item[prop] === 'object');

            if (dataProperty) {
                Object.keys(item[dataProperty]).forEach(year => {
                    const sheetData = item[dataProperty][year];
                    const keys = Object.keys(sheetData[0]);
      //const transformedData = sheetData.map(entry => [year, ...keys.map(key => entry[key])]);

                    const transformedData = sheetData.map(entry => {
                        // Check if "dim_3" is "T", skip the entry if true
                        if (entry.dim_3 === "T") {
                            return null; // Skip this entry
                        }
                        return [year, ...keys.map(key => entry[key])];
                    }).filter(Boolean); // Filter out null entries

                    if (allSheetData[sheetName].length === 0) {
                        transformedData.unshift(['Year', ...keys]); // Add headers only once
                    }

                    allSheetData[sheetName].push(...transformedData);
                });
            }
        }
    }
};

export const handleUrl = (data, allFilesData) => {
    let allSheetData = {};

    try {
        const jsonData = data;
        processJsonData(jsonData, allSheetData);
    } catch (error) {
        console.error('Error parsing JSON file:', error);
    }

    // Combine all sheets into a single array
    const combinedSheetData = Object.keys(allSheetData).map(sheetName => ({
        sheetName,
        data: allSheetData[sheetName]
    }));

    allFilesData.push(...combinedSheetData);

    return allFilesData;
};

export const handleFile = (file, data, allFilesData, files_number, setFilesSelected, setHealthData) => {
    let allSheetData = {};

    if (file.name.toLowerCase().endsWith('.json')) {
        try {
            const jsonData = JSON.parse(decodeURIComponent(escape(data)));
            processJsonData(jsonData, allSheetData);
        } catch (error) {
            console.error('Error parsing JSON file:', error);
        }
    } else {
        // Parse the XLSX data using xlsx library
        const workbook = XLSX.read(data, { type: 'binary', cellText: false, cellDates: true, raw: true });

        workbook.SheetNames.forEach(sheetName => {
            const worksheet = workbook.Sheets[sheetName];

            // Convert worksheet to JSON but manually handle cell values to ensure no type conversion
            const jsonData = XLSX.utils.sheet_to_json(worksheet, {
                header: 1, // Read data as a 2D array
                raw: true, // Keep raw data without parsing
            }).map(row =>
                row.map(cell => typeof cell === 'undefined' || cell === null ? '' : cell.toString()) // Convert everything to string
            );

            if (file.name.toLowerCase().endsWith('.csv')) {

                const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");
                allSheetData[fileNameWithoutExtension] = jsonData;
            } else {
                allSheetData[sheetName] = jsonData;
            }
        });
    }

    // Combine all sheets into a single array
    const combinedSheetData = Object.keys(allSheetData).map(sheetName => ({
        sheetName,
        data: allSheetData[sheetName]
    }));

    allFilesData.push(...combinedSheetData); // Add data of this file to all files' data array

    setHealthData(allFilesData.flat()); // Flatten the array and set data
    setFilesSelected(true); // Files are selected, set to true

};

export const List = ({ title, data, selectedData, setSelectedData, valueType, valueType2, placeholder, setSelectedColumn, setSelectedDatasets }) => {

  const options = Object.values(data).map(item => ({
    value: item[valueType],
    label: item[valueType2]
  }));


  const handleChange = selectedOption => {
    setSelectedColumn?.('');
    setSelectedDatasets?.('');

    setSelectedData(selectedOption ? String(selectedOption.value) : '');
  };

  const selectedOption = options.find(option => String(option.value).trim() === selectedData);

  return (
    <div className="dropdown-container">
      <label className="project-name-label">{title}</label>
      <Select
        value={selectedOption || null}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        className="dropdown-select"
      />
    </div>
  );
};

export const MultiSelectDropdown = ({ title, data, selectedData, setSelectedData, valueType, valueType2, placeholder }) => {
  const options = data.map(item => ({
    value: item[valueType],
    label: item[valueType2]
  }));

  const handleChange = selectedOptions => {
    setSelectedData(selectedOptions ? selectedOptions.map(option => String(option.value)) : []);
  };

  const selectedOptions = options.filter(option => selectedData.includes(String(option.value)));

  return (
    <div className="dropdown-container">
      <label className="project-name-label">{title}</label>
      <Select
        isMulti
        value={selectedOptions}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        className="dropdown-select"
      />
    </div>
  );
};

export const DatasetSelector = ({ columns, selectedDatasets, setSelectedDatasets, selectedColumn, setSelectedColumn }) => {

  return (
<>
    <List
            title="Label"
            data={columns}
            selectedData={selectedColumn}
            setSelectedData={setSelectedColumn}
            valueType="column_id"
            valueType2="column_name"
            placeholder="Selecionar label"
          />

<MultiSelectDropdown
        title="Datasets"
        data={columns}
        selectedData={selectedDatasets}
        setSelectedData={setSelectedDatasets}
        valueType="column_id"
        valueType2="column_name"
        placeholder="Selecionar datasets"
      />
    </>
  );
};

const LeftSection = ({ title, topics }) => {
  return (
    <div className="left-section">
      <h2 className="title">{title}</h2>
      <ul className="topics">
        {topics.map((topic, index) => (
          <li key={index}>{topic}</li>
        ))}
      </ul>
    </div>
  );
};

export const GraphicTypeContainer = ({ title, topics, selectedDatasets, tableColumnData, setGraphType, graphType, chartGroup }) => {
  return (
    <div className="graphicTypecontainer">
      <LeftSection title={title} topics={topics} />
      <div className="right-section">
        <ChartSelector
          selectedDatasets={selectedDatasets}
          tableColumnData={tableColumnData}
          setGraphType={setGraphType}
          graphType={graphType}
          chartGroup={chartGroup}
        />
      </div>
    </div>
  );
};

export const ChartSelector = ({ selectedDatasets, tableColumnData, setGraphType, graphType, chartGroup }) => {

  const inferBestGraphType = (datasetColumnIds, tableColumnData, selectedDatasets) => {
  if (selectedDatasets.length === 0) {
    return []; // No graph type can be inferred
  }

  const recommendedTypes = [];

  recommendedTypes.push('1'); //line
  recommendedTypes.push('2'); //area
  recommendedTypes.push('17'); //scatter
  recommendedTypes.push('18'); //bubble

  if (selectedDatasets.length === 1) {
    recommendedTypes.push('25'); //big number
  }

  if (selectedDatasets.length === 2) {
    recommendedTypes.push('26'); //timeline
  }

  const numDataPoints = selectedDatasets.reduce((total, id) => total + tableColumnData[id].data.length, 0);

  const numPointsPerDataset = numDataPoints / selectedDatasets.length;

if (numPointsPerDataset < 11) {
  // Always recommended if numPointsPerDataset < 11
  recommendedTypes.push('3');  // bar
  recommendedTypes.push('4');  // doughnut
  recommendedTypes.push('5');  // treemap
  recommendedTypes.push('21'); // table

  // Additional recommendations based on the number of selected datasets
  if (selectedDatasets.length > 1) {
    recommendedTypes.push('12');  // stacked vertical
    recommendedTypes.push('13');  // stacked horizontal
    recommendedTypes.push('14');  // bar multiple vertical
    recommendedTypes.push('15');  // bar multiple horizontal
    recommendedTypes.push('19');  // radar
  } else {
    recommendedTypes.push('6');  // vertical
    recommendedTypes.push('7');  // horizontal
  }
}

  return recommendedTypes;
};

  const chartComponents = chartComponentsMap[chartGroup];

  // Convert the numerical value returned by inferBestGraphType to the corresponding key
  const bestGraphTypeKey = inferBestGraphType(selectedDatasets, tableColumnData, selectedDatasets);

  return (
    <div>
      {Object.entries(chartComponents).map(([key, { label, icon }]) => (
        <span
          key={key}
          onClick={() => setGraphType(key)}
          className={`chart-icon ${graphType === key ? 'selected' : ''} ${bestGraphTypeKey.includes(key) ? 'recommended' : ''}`}
        >
          {icon && React.createElement(icon, { style: {} })}
        </span>
      ))}
    </div>
  );
};

export const Pagination = ({ currentPage, setCurrentPage, itemsPerPage, DataArray }) => {
  const indexOfLastItem = currentPage * itemsPerPage;

  return (
    DataArray.length > itemsPerPage && (
      <div className="pagination-buttons">
        <button
          className="previous-button"
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <LeftIcon className="icon" />
          <span className="text">Anterior</span>
        </button>
        {renderPageNumbers({ currentPage , setCurrentPage, DataArray, itemsPerPage})}
        <button
          className="next-button"
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={indexOfLastItem >= DataArray.length }
        >
          <span className="text">Seguinte</span>
          <RightIcon className="icon" />
        </button>
      </div>
    )
  );
};

export const renderPageNumbers = ({ currentPage , setCurrentPage, DataArray, itemsPerPage}) => {
  const pageNumbers = [];
  const maxPagesToShow = 5; // Change this value to show more or fewer pages
  const totalPages = Math.ceil(DataArray.length / itemsPerPage);

  // Add the first page
  pageNumbers.push(
    <button
      key={1}
      onClick={() => setCurrentPage(1)}
      className={`page-number ${currentPage === 1 ? 'active' : ''}`}
    >
      1
    </button>
  );

  // Add ellipses if necessary
  if (currentPage > maxPagesToShow) {
    pageNumbers.push(<span key="start-ellipsis" className="ellipsis">...</span>);
  }

  // Calculate the start and end page numbers
  const startPage = Math.max(2, currentPage - 2);
  const endPage = Math.min(totalPages - 1, currentPage + 2);

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(
      <button
        key={i}
        onClick={() => setCurrentPage(i)}
        className={`page-number ${currentPage === i ? 'active' : ''}`}
      >
        {i}
      </button>
    );
  }

  // Add ellipses if necessary
  if (currentPage + 2 < totalPages - 1) {
    pageNumbers.push(<span key="end-ellipsis" className="ellipsis">...</span>);
  }

  // Add the last page
  if (totalPages > 1) {
    pageNumbers.push(
      <button
        key={totalPages}
        onClick={() => setCurrentPage(totalPages)}
        className={`page-number ${currentPage === totalPages ? 'active' : ''}`}
      >
        {totalPages}
      </button>
    );
  }

  return (
    <div style={{ maxWidth: '350px' }}>
      {pageNumbers}
    </div>
  );
};

export const ItemList = ({
  tipo,
  isLoaded,
  onView,
  onEdit,
  onDelete,
  onDuplicate,
  onExport,
  onShare,

  currentPage,
  setCurrentPage,
  itemsPerPage,
  DataArray
}) => {

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  function convertToArray(data) {
  if (Array.isArray(data)) {
    // If `data` is already an array, return it as-is
    return data;
  } else if (data !== null && typeof data === 'object') {
    // If `data` is an object, convert it to an array of values
    return Object.entries(DataArray).map(([id, item]) => ({ ...item, [`${tipo}Id`]: id }));
  } else {
    // If `data` is neither an array nor an object, return an empty array
    return [];
  }
}
let newArray = convertToArray(DataArray);



let currentData = newArray.slice(indexOfFirstItem, indexOfLastItem);

const idMap = {
  widget: 'widgetId',
  table: 'table_id',
  dashboard: 'dashboardId',
  project: 'database_id'
};

const nameMap = {
  widget: 'name',
  table: 'table_name',
  dashboard: 'name',
  project: 'database_name'
};

let items = currentData.map(item => ({
  id: item[idMap[tipo]],
  name: item[nameMap[tipo]],
  isRealTime: item.type === 'real-time', // Check if the item is a real-time source
  isShared: item.isShared === 1 || item.isShared === 2, // Check if the item is shared or owned and shared
    isOwnedAndShared: item.isShared === 2, // Check if the item is both owned and shared
    permission: item.permission
}));



  if (!isLoaded) {
    return null;
  }

  if (newArray.length === 0){
    return (
      <div className="frame-container">
      <div className="no-items-container">
        {tipo === 'table' && (
          <>
            <DadosBigIcon />
            <span>Sem dados disponíveis</span>
          </>
        )}
        {tipo === 'widget' && (
          <>
            <WidgetsBigIcon />
            <span>Sem widgets disponíveis</span>
          </>
        )}
        {tipo === 'project' && (
          <>
            <ProjetosBigIcon />
            <span>Sem projetos disponíveis</span>
          </>
        )}
        {tipo === 'dashboard' && (
          <>
            <DashboardsBigIcon />
            <span>Sem dashboards disponíveis</span>
          </>
        )}
      </div>
    </div>
    );
  }

  return (
    <>
    <ul>
      {items.map((item) => (
        <li key={item.id}>
          <div className="project-info">
              <span>
                {item.name}{' '}
                {item.isRealTime && (
                  <span style={{
                    color: '#d9534f', // Red color to indicate real-time
                    fontSize: '0.9em',
                    marginLeft: '5px',
                    fontWeight: 'bold'
                  }}>
                    [Tempo-Real]
                  </span>
                )}{item.isOwnedAndShared && ( // Display a badge or indicator for owned and shared items
                  <span style={{
                    color: '#28a745', // Green color for owned and shared indicator
                    fontSize: '0.9em',
                    marginLeft: '5px',
                    fontWeight: 'bold'
                  }}>
                    [Partilhado por Mim]
                  </span>
                )}
                {item.isShared && !item.isOwnedAndShared && (
  <span style={{
      color: '#007bff', // Blue color for shared indicator
      fontSize: '0.9em',
      marginLeft: '5px',
      fontWeight: 'bold'
    }}>
    [Partilhado Comigo]
    {item.permission && (
      <span style={{
        color: '#6c757d', // Grey color for permission indication
        fontSize: '0.9em',
        marginLeft: '5px',
        fontWeight: 'normal'
      }}>
        ({item.permission === 'read-only' ? 'Leitura' : 'Edição'})
      </span>
    )}
  </span>
)}
              </span>
              <div className="icons-container">
            {onView && (
                <EyeIcon
                  onClick={() => onView(item.id)}
                  style={{ cursor: 'pointer' }}
                />
              )}




              <PenIcon
  onClick={() => {
    // Disable on duplicate for 'widget' if permission is 'read-only'
    if ((tipo !== 'widget') || item.permission !== 'read-only') {
      onEdit(item.id);
    }
  }}
  style={{
    cursor: (tipo === 'widget') && item.permission === 'read-only' ? 'not-allowed' : 'pointer',
    opacity: (tipo === 'widget') && item.permission === 'read-only' ? 0.5 : 1
  }}
  disabled={(tipo === 'widget') && item.permission === 'read-only'} // Disable for widget with read-only permission
/>








              {onDuplicate && (
                  <CopyIcon
  onClick={() => {
    // Disable on duplicate for 'table', 'widget', and 'dashboard' if permission is 'read-only'
    if ((tipo !== 'table' && tipo !== 'widget' && tipo !== 'dashboard') || item.permission !== 'read-only') {
      onDuplicate(item.id);
    }
  }}
  style={{
    cursor: (tipo === 'table' || tipo === 'widget' || tipo === 'dashboard') && item.permission === 'read-only' ? 'not-allowed' : 'pointer',
    opacity: (tipo === 'table' || tipo === 'widget' || tipo === 'dashboard') && item.permission === 'read-only' ? 0.5 : 1
  }}
  disabled={(tipo === 'table' || tipo === 'widget' || tipo === 'dashboard') && item.permission === 'read-only'} // Disable for table, widget, and dashboard with read-only permission
/>


                )}
              <TrashIcon
  onClick={() => {
    // Disable delete for 'table', 'widget', and 'dashboard' if permission is 'read-only'
    if ((tipo !== 'table' && tipo !== 'widget' && tipo !== 'dashboard') || item.permission !== 'read-only') {
      onDelete(item.id);
    }
  }}
  style={{
    cursor: (tipo === 'table' || tipo === 'widget' || tipo === 'dashboard') && item.permission === 'read-only' ? 'not-allowed' : 'pointer',
    opacity: (tipo === 'table' || tipo === 'widget' || tipo === 'dashboard') && item.permission === 'read-only' ? 0.5 : 1
  }}
  disabled={(tipo === 'table' || tipo === 'widget' || tipo === 'dashboard') && item.permission === 'read-only'} // Disable for table, widget, and dashboard with read-only permission
/>




              {onExport && (
                <ExportIcon
                  onClick={() => onExport(item.id)}
                  style={{ cursor: 'pointer' }}
                />
              )}
              {onShare && (
                  <ShareIcon
                    onClick={() => {
                      if (!item.isShared || item.isOwnedAndShared) onShare(item.id);
                    }}
                    style={{
                      cursor: item.isShared && !item.isOwnedAndShared ? 'not-allowed' : 'pointer',
                      opacity: item.isShared && !item.isOwnedAndShared ? 0.5 : 1
                    }}
                    disabled={item.isShared && !item.isOwnedAndShared} // Grey out button for shared-with-me items
                  />
                )}
            </div>
          </div>
        </li>
      ))}
    </ul>

    <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        DataArray={newArray}
        itemsPerPage={itemsPerPage}
      />

      </>
  );
};

//Delete success **************************************************************

export function renderModal(isOpen, message, onClose, color, iconID) {
  return (
    isOpen && (
      <div className="modal">
        <span className="close" onClick={onClose}>&times;</span>
        {iconID === 1 ? (
          <HappyIcon />

        ) : iconID === 2 ? (
          <SadIcon/>

        ) : iconID === 3 ? (
          <SaveIcon/>

        ) : color === '#E5004E' ? (
          <TrashIcon className="trash-icon-pink" />
        ) : color === '#233A80' ? (
          <ExportIcon className="export-icon-gray" />
        ) : (
          <CopyIcon />
        )}
        <p style={{ color: color }}>{message}</p>
      </div>
    )
  );
};

export function closeModal(setIsOpen) {
  return () => {
    setIsOpen(false);
  };
}

//Are you sure you want delete ******************************************

export const renderConfirmationModal = (isOpen, message, onConfirm, onCancel) => {
    return (
        isOpen && (
            <div className="ConfirmationModal">
                <TrashIcon />
                <p>{message}</p>
                <div className="ButtonContainer">
                  <button onClick={onConfirm}>Sim</button>
                  <button onClick={onCancel}>Não</button>
                </div>
            </div>
        )
    );
};

export const handleDelete = async (resourceType, projectId, resourceId, token, setResource, allResources, setModalMessage, setModalMessageColor, setIsModalOpen, currentPage, setCurrentPage, itemsPerPage) => {

  const url = projectId ? `${API_BASE_URL}/${resourceType}/${projectId}/${resourceId}` :
  `${API_BASE_URL}/${resourceType}/${resourceId}`;


  try {
    await axios.delete(url, {
      headers: {
        Authorization: `Bearer ${token}` // Include JWT token in Authorization header
      }
    });


    const updatedResources = { ...allResources };
    delete updatedResources[resourceId];
    setResource(updatedResources);

    let message = `${resourceType === 'widgets' ? 'Widget eliminado!' : 'Dados eliminados!'}`;


    setModalMessage(message);
    setModalMessageColor('#E5004E');
    setIsModalOpen(true);

    const newNumPages = Math.ceil((Object.keys(updatedResources).length) / itemsPerPage);

    // If the current page is greater than the new number of pages after deletion,
    // set the current page to the last page
    if (currentPage > newNumPages) {
      setCurrentPage(newNumPages);
    }

  } catch (error) {
    console.error(`Ocorreu um problema ao eliminar o${resourceType === 'widgets' ? ' widget' : 's dados'}... `, error);
  }
};

export const handleDuplicate = async (type, id, setData, data, successMessage, setIsDuplicating, setModalMessage, setModalMessageColor, setIsModalOpen) => {
  try {
    setIsDuplicating(true); // Set the flag to indicate duplication process started
    const token = localStorage.getItem('token');
    const response = await axios.post(`${API_BASE_URL}/duplicate-${type}/${id}`, null, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    // Assuming response.data contains the newly duplicated item
    const duplicatedItem = response.data[`duplicated${type.charAt(0).toUpperCase() + type.slice(1)}`];

    // Update the list with the duplicated item
    if (type === 'project') {
      setData([...data, duplicatedItem]);
    } else if (type === 'widget' || type === 'dashboard' || type === 'table') {
      setData({ ...data, ...duplicatedItem });
    }

    setIsDuplicating(false); // Set the flag to indicate duplication process ended
    setModalMessage(successMessage);
    setModalMessageColor('');
    setIsModalOpen(true);
  } catch (error) {
    console.error(`Error duplicating ${type}:`, error);
    setIsDuplicating(false); // Set the flag to indicate duplication process ended (in case of error)
  }
};

export const fetchData = async (url, setData, setIsLoaded, dataKey, sharecode, dashboardId ) => {
  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'dashboardid': dashboardId,
        'sharecode': sharecode,

      }
    });
    setData(response.data[dataKey]);

    setIsLoaded(true);
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

export const makePostRequest = async (url, data) => {
  try {
    const response = await axios.post(url, data, { headers: {
  Authorization: `Bearer ${localStorage.getItem('token')}`
} });
    console.log('Request successful:', response);
    return response; // Return response data for further use if needed
  } catch (error) {
    console.error('Error making POST request:', error);
    throw error; // Re-throw the error for further handling if needed
  }
};

export const LoadingOverlay = ({ isDuplicating, spinnerMessage }) => {
  const loadingMessage = spinnerMessage || 'A Duplicar...';

  return (
    isDuplicating && (
      <div className="loading-overlay">
        <div className="loading-spinner"></div>
        <div className="loading-message">{loadingMessage}</div>
      </div>
    )
  );
};

 export const fetchJsonFromUrl = async (url) => {
    try {
      //const response = await axios.get(url);
      const response = await axios.get(`${API_BASE_URL}/proxy?url=${encodeURIComponent(url)}`);

      let allFilesData = [];

      return handleUrl(response.data, allFilesData);
    } catch (error) {
      console.error('Error fetching JSON from URL:', error);
      return null;
    }
  };

  const staticColors = [
  'rgba(255, 99, 132, 1)',  // Red
  'rgba(54, 162, 235, 1)',  // Blue
  'rgba(255, 206, 86, 1)',  // Yellow
  'rgba(75, 192, 192, 1)',  // Green
  'rgba(153, 102, 255, 1)', // Purple
  'rgba(255, 159, 64, 1)',  // Orange
  'rgba(199, 199, 199, 1)', // Grey
  'rgba(255, 99, 255, 1)',  // Pink
  'rgba(99, 255, 132, 1)',  // Light Green
  'rgba(99, 132, 255, 1)'   // Light Blue
];

  function getRandomColor() {
  const r = Math.floor(Math.random() * 256);
  const g = Math.floor(Math.random() * 256);
  const b = Math.floor(Math.random() * 256);
  return `rgba(${r}, ${g}, ${b}, 1)`;
}
  function transformDataWithRandomColors(data) {
  const colorMap = data.labels.map((_, index) => {
    // Use static colors for the first 10 labels, random colors for others
    return index < staticColors.length ? staticColors[index] : getRandomColor();
  });

  // Apply the same colors to all datasets
  return {
    ...data,
    datasets: data.datasets.map((dataset) => ({
      ...dataset,
      backgroundColor: colorMap,  // Use the static/random colors for all datasets
    }))
  };
}

  function transformDataForBubbleChart(inputData) {
    const { labels, datasets } = inputData;

    // Check if labels exist
    if (!labels || labels.length === 0) {
        throw new Error("Input data must contain labels.");
    }

    const bubbleData = {
        labels, // Preserve labels if needed for other uses
        datasets: [], // This will hold the bubble data points
    };

    // Step 1: Calculate the maximum data value across all datasets for scaling the bubble size
    let maxDataValue = 0;
    datasets.forEach(dataset => {
        dataset.data.forEach(value => {
            if (value > maxDataValue) {
                maxDataValue = value;
            }
        });
    });

    // Step 2: Create bubble data points for each dataset, using the maximum value for scaling
    datasets.forEach((dataset, datasetIndex) => {
        const yData = dataset.data; // Y-axis values for this dataset

        // Create a bubble series for the current dataset
        const bubbleSeries = {
            label: dataset.label || `Dataset ${datasetIndex + 1}`, // Use provided label or default
            backgroundColor: dataset.backgroundColor || "rgba(91,106,172,0.5)", // Default color
            borderColor: dataset.borderColor || "rgba(0,0,0,1)",
            borderWidth: 2,
            data: [], // This will hold the bubble data points
        };

        labels.forEach((label, index) => {
            const yValue = yData[index];

            // Ensure valid values before pushing to bubble data
            if (yValue !== undefined) {
                // Step 3: Scale the bubble radius based on the value relative to the maximum data value
                const radius = Math.sqrt(yValue / maxDataValue) * 25; // Scale to a reasonable size

                bubbleSeries.data.push({
                    x: index, // X-axis value (using index for position)
                    y: yValue, // Y-axis value (e.g., Area or GDP)
                    r: radius > 0 ? radius : 1, // Ensure radius is greater than 0
                });
            }
        });

        // Add the bubble series to the main bubble data
        bubbleData.datasets.push(bubbleSeries);
    });

    return bubbleData;
}


  export function renderChart(graphType, data, handleClick, Id) {
  // Determine the ChartComponent based on the graphType
  const ChartComponent = chartComponents[graphType]?.component; // Optional chaining for safety



  // Determine the data to use based on the graphType
  const chartData = (graphType === '18' || graphType === '17')
  ? transformDataForBubbleChart(data)  // Existing logic for bubble charts
  : (graphType === '4' || graphType === '3')
  ? transformDataWithRandomColors(data)  // Apply random colors for Doughnut chart
  : data;  // Default to original data for other chart types

  // Create custom options including the click handler
  const customOptions = {
    ...chartComponents[graphType]?.options,
    onClick: (e, elements) => {
      if (elements.length > 0 && handleClick) {
        // Get the clicked label from the chart's data
        const clickedLabel = chartData.labels[elements[0].index]; // Use chartData instead of data
        handleClick(clickedLabel); // Trigger the drill-down
      }
    },
  };

  // Return the ChartComponent with the determined data
  return ChartComponent ? (
    <ChartComponent
      id={Id} // Correct casing for id
      data={chartData} // Use the appropriate data
      options={customOptions}
    />
  ) : null;
}



/*
export function GraphData(labelsColumnId, datasetColumnIds, tableColumnData) {
  const labels = tableColumnData[labelsColumnId].data;

  const datasets = datasetColumnIds.map(datasetColumnId => {
    return {
      label: tableColumnData[datasetColumnId].column_name,
      backgroundColor: `rgba(${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},1)`,
      borderColor: 'rgba(0,0,0,1)',
      borderWidth: 2,
      data: tableColumnData[datasetColumnId].data
    };
  });

  return { labels, datasets };
}*/

export function GraphData(labelsColumnId, datasetColumnIds, tableColumnData, conteudo) {

  if(conteudo) return (conteudo);

  //if selectedDatasets. return {};
  const rawLabels = tableColumnData[labelsColumnId].data;  // Continent data

  // Step 1: Identify unique labels (continents)
  const uniqueLabels = Array.from(new Set(rawLabels));

  // Step 2: Initialize an empty array for each dataset column (Population and Area)
  const aggregatedData = datasetColumnIds.map(() => new Array(uniqueLabels.length).fill(0));
const concatenatedData = datasetColumnIds.map(() => new Array(uniqueLabels.length).fill('')); // To store concatenated strings

rawLabels.forEach((label, index) => {
    const uniqueIndex = uniqueLabels.indexOf(label);  // Find index of the continent

    datasetColumnIds.forEach((datasetColumnId, datasetIndex) => {
        const currentValue = tableColumnData[datasetColumnId].data[index];
        const numericValue = Number(currentValue);

        // Check if the current value is numeric
        if (!isNaN(numericValue)) {
            // If it's numeric, accumulate it in aggregatedData
            aggregatedData[datasetIndex][uniqueIndex] += numericValue;
        } else {
            // If it's non-numeric, concatenate it
            concatenatedData[datasetIndex][uniqueIndex] += String(currentValue) + ' '; // Add a space between concatenated values
        }
    });
});

// Step 4: Create the datasets array with aggregated or concatenated data
const datasets = datasetColumnIds.map((datasetColumnId, datasetIndex) => {
    // Check if there's any non-numeric data in this dataset
    const hasNonNumeric = concatenatedData[datasetIndex].some(value => value.trim() !== '');

    return {
        label: tableColumnData[datasetColumnId].column_name,  // e.g., Population, Area
        backgroundColor: `rgba(${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},1)`,
        borderColor: 'rgba(0,0,0,1)',
        borderWidth: 2,
        // Use concatenated data if there's any non-numeric data; otherwise, use aggregated data
        data: hasNonNumeric ? concatenatedData[datasetIndex] : aggregatedData[datasetIndex].map(num => (num === 0 ? '' : num)) // Convert zeros to empty strings for visual clarity
    };
});


  // Step 5: Return unique labels (continents) and the aggregated datasets
  return { labels: uniqueLabels, datasets };
}

const graphicTypeContainersData = [
  {
    title: "Mostrar um grande número",
    topics: [
      'Número de items vendidos',
      'Receita bruta, receita líquida',
      'Número de visitantes de um site'
    ],
    chartGroup: 1
  },
  {
    title: "Comparar valores com e entre grupos",
    topics: [
      'Qual é a população dos países europeus?',
      'Quais são meus números de vendas nesses países?',
      'Quem são os melhores vendedores da minha empresa?'
    ],
    chartGroup: 2
  },
  {
    title: "Mostrar a posição relativa dos dados",
    topics: [
      'Alocação de mulheres e homens entre clientes',
      'Inscrições aprovadas e negadas para uma escola',
      'Participação das vendas de 1 região nas vendas de toda a empresa'
    ],
    chartGroup: 3
  },
  {
    title: "Mostrar a mudança ao longo do tempo",
    topics: [
      'Tendência de vendas no último ano',
      'Tendência do número de visitantes da página da web',
      'Quantidade de tickets de suporte que chegam ao suporte técnico diariamente'
    ],
    chartGroup: 4
  },
  {
    title: "Explicar a relação entre métricas",
    topics: [
      'Como os gastos da campanha se relacionam com a receita em muitas campanhas diferentes?',
      'Qual é a relação entre o número de pedidos e a receita total por categoria de produto?'
    ],
    chartGroup: 5
  },
  {
    title: "Traçar dados geográficos",
    topics: [
      'Distribuição de clientes entre cidades',
      'Número de pessoas que vivem nas cidades',
      'Receitas por região'
    ],
    chartGroup: 6
  },
  {
    title: "Ver detalhes em tabela",
    topics: [
      'Detalhes dos produtos – categoria do produto, items vendidos, preço médio,% da receita',
      'Detalhes do cliente – nome, e-mail, número de pedidos, receita total'
    ],
    chartGroup: 7
  }
];

export const ListWithDatasetSelector = ({
  data,
  selectedData,
  setSelectedData,
  isDataLoaded,
  selectedColumn,
  setSelectedColumn,
  selectedDatasets,
  setSelectedDatasets
}) => {
  return (
    <div className="lists-container">
      <List
        title="Tabela"
        data={data}
        selectedData={selectedData}
        setSelectedData={setSelectedData}
        valueType="table_id"
        valueType2="table_name"
        placeholder="Selecionar tabela"

        setSelectedColumn={setSelectedColumn}
        setSelectedDatasets={setSelectedDatasets}
      />

      {isDataLoaded && selectedData !== "" && (
        <DatasetSelector
          columns={data[selectedData]?.columns || []}
          selectedDatasets={selectedDatasets}
          setSelectedDatasets={setSelectedDatasets}
          selectedColumn={selectedColumn}
          setSelectedColumn={setSelectedColumn}
        />
      )}
    </div>
  );
};

export const GraphicTypeContainers = ({ selectedDatasets, tableColumnData, setGraphType, graphType }) => {
  return (
    <>
      {graphicTypeContainersData.map((containerData, index) => (
        <GraphicTypeContainer
          key={index}
          title={containerData.title}
          topics={containerData.topics}
          selectedDatasets={selectedDatasets}
          tableColumnData={tableColumnData}
          setGraphType={setGraphType}
          graphType={graphType}
          chartGroup={containerData.chartGroup}
        />
      ))}
    </>
  );
};


export const ChartWidget = ({ tableColumnData, graphType, selectedColumn, selectedDatasets, buttonLabel, onButtonClick, widget, height, tables, Id }) => {

  tableColumnData=evaluateData(tableColumnData);

  const getTableIdByColumnId = (columnId) => {
    for (const table of Object.values(tables)) {
        const column = table.columns.find(col => col.column_id === columnId);
        if (column) {
            return table.table_id;
        }
    }
    return null; // Return null if not found
};

  const [drillLevelIndex, setDrillLevelIndex] = useState(0);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [nextColumnId, setNextColumnId] = useState(null);

  const [startColumnId, setStartColumnId] = useState(null);
  let widgetId = 0;

if (!height) {height='600px'}

if (widget) {
    widgetId = Object.keys(widget)[0];
//console.log(Id + "xx: " + JSON.stringify(widgetId));
    graphType = widget[widgetId].graph_type.toString();
    selectedDatasets = widget[widgetId].columns.map(columnId => String(columnId))

selectedColumn = drillLevelIndex === 0
    ? widget[widgetId].label_id.toString() // Start with the widget's initial label
    : (nextColumnId).toString();
}

selectedColumn = drillLevelIndex === 0
    ? selectedColumn // Start with the widget's initial label
    : (nextColumnId).toString();

    const getOrderedColumnIds = () => {

  const tableId = getTableIdByColumnId(parseInt(selectedColumn));
  const columns = tables[tableId].columns;

  return columns
    .sort((a, b) => a.column_order - b.column_order)
    .map(column => column.column_id);
};


    const getNextColumn = (offset) => {
  const orderedColumnIds = getOrderedColumnIds();
  const selectedColumnIndex = orderedColumnIds.indexOf(parseInt(selectedColumn));

  return (selectedColumnIndex !== -1 && selectedColumnIndex + offset < orderedColumnIds.length)
    ? orderedColumnIds[selectedColumnIndex + offset]
    : null;
};

  const handleDrillUp = () => {
      if (drillLevelIndex > 0) {
      const next = getNextColumn(-1);
      setNextColumnId(next);
      setDrillLevelIndex(drillLevelIndex - 1);
      const updatedLabels = [...selectedLabels];
      updatedLabels.pop();
      setSelectedLabels(updatedLabels);
    }
  };

  const handleDrillClick = (clickedLabel) => {
  const next = getNextColumn(1);
  const nextColumnData = next ? tableColumnData[next] : null;



  if (nextColumnData) {

    const isNumericData = nextColumnData.data.every(data =>
      /^[0-9.,]+$/.test(data)  // Allow digits, commas, and periods
    );

    if (!isNumericData) {
      setNextColumnId(next);
      setDrillLevelIndex(drillLevelIndex + 1);
      setSelectedLabels([...selectedLabels, clickedLabel]); // Store the current selection in the drill-down chain
    } else {
      console.log("Drill-down not allowed: the next column contains only numeric data");
    }
  } else {
    console.log("No further drill-down allowed");
  }
};

  let filteredTableColumnData = { ...tableColumnData };

if (selectedLabels){
  if (selectedLabels.length > 0) {



    const selectedColumnIndex = getOrderedColumnIds().indexOf(parseInt(selectedColumn));
    if(!startColumnId) setStartColumnId(selectedColumnIndex);

    // For each drill-down level, filter based on the corresponding selected label
    selectedLabels.forEach((label, level) => {

//console.log("startColumnId" + startColumnId);
      const indice = (startColumnId ?? selectedColumnIndex) + level-1;

      const columnIdForLevel = getOrderedColumnIds()[indice];
      const selectedColumnData = tableColumnData[columnIdForLevel];
      // Get row_ids where the selectedColumn's data matches the label at the current drill level
      const matchingRowIds = selectedColumnData.row_id.filter((rowId, index) => {
        return selectedColumnData.data[index] === selectedLabels[level]; // Match data for the current level
      });

      // Filter each column's data based on these matching row_ids
      for (let columnId in filteredTableColumnData) {
        if ([selectedColumn, ...selectedDatasets].includes(columnId)) {
          const columnData = filteredTableColumnData[columnId];
          filteredTableColumnData[columnId] = {
            ...columnData,
            data: columnData.data.filter((_, index) => matchingRowIds.includes(columnData.row_id[index])),
            row_id: columnData.row_id.filter(rowId => matchingRowIds.includes(rowId)),
          };
        }
      }
    });
  }
}

const content = widget?.widget_id?.conteudo || null;


  return (<>

    {drillLevelIndex > 0 && (
          <button
    onClick={handleDrillUp}
    style={{
      marginBottom: '10px',
      padding: '8px 16px', // Adjust padding for better appearance
      backgroundColor: '#4CAF50', // Green background
      color: 'white', // White text
      border: 'none', // Remove default border
      borderRadius: '4px', // Rounded corners
      cursor: 'pointer', // Pointer cursor on hover
      fontSize: '14px', // Font size
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // Add a subtle shadow
      transition: 'background-color 0.3s', // Smooth hover effect
    }}
    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#45a049')} // Darker green on hover
    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#4CAF50')} // Restore color on mouse out          em baixo 600px height
  >
    Roll Up
  </button>
        )}
    {graphType && selectedColumn && selectedDatasets.length > 0 ? (
  <>
    <div style={{ height: height, width: '100%' }}>
      {renderChart(graphType, GraphData(selectedColumn, selectedDatasets, filteredTableColumnData, content), handleDrillClick, Id)}
    </div>
    {buttonLabel && (
      <button
        className="button"
        onClick={() => onButtonClick(selectedDatasets, selectedColumn, graphType)}>
        {buttonLabel}
      </button>
    )}
  </>
) : null}

  </>);
};

export const evaluateData = (data) => {
    const updatedData = { ...data };

    // Generic function to evaluate formulas
    const evaluateFormula = (formula, index, data) => {
        if (!formula) return "";

        // Replace column references with actual values
        const updatedFormula = formula.replace(/C(\d+)/g, (match, colId) => {
            const colData = data[colId]?.data ?? '';

            return colData[index] || 0; // Return the value for the current row or 0 if undefined
        });

        try {

            // Evaluate the expression safely
            return eval(updatedFormula.replace(/,/g, '.')); // WARNING: Using eval can be dangerous with untrusted input
        } catch (error) {
            console.error("Error evaluating formula:", error);
            return "";
        }
    };

    // Iterate over each column to find formulas
    Object.entries(updatedData).forEach(([colId, colData]) => {
        if (colData.formula) {
            // Populate the data based on the formula for each row
            updatedData[colId].data = colData.data.map((_, index) =>
                evaluateFormula(colData.formula, index, updatedData)
            );
        }
    });

    return updatedData;
};
